var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { compose, withStateHandlers, withHandlers, mapProps, lifecycle } from "recompose";
import { upperFirst, omit, identity } from "lodash";
// Handle all backend APIs
function withFetcher(name, fetch, _a) {
    var _b = (_a === void 0 ? {} : _a).fetchOnMount, fetchOnMount = _b === void 0 ? false : _b;
    var _c, _d, _e;
    return compose(withStateHandlers((_c = {},
        _c[name + "Fetcher"] = {
            data: null,
            loading: false,
            error: null
        },
        _c), (_d = {},
        _d["receive" + upperFirst(name) + "Data"] = function () { return function (data) {
            var _a;
            return (_a = {},
                _a[name + "Fetcher"] = {
                    data: data,
                    loading: false,
                    error: null
                },
                _a);
        }; },
        _d["receive" + upperFirst(name) + "Error"] = function (_a) {
            var _b = name + "Fetcher", data = _a[_b].data;
            return function (error) {
                var _a;
                return (_a = {},
                    _a[name + "Fetcher"] = {
                        data: data,
                        loading: false,
                        error: error || true
                    },
                    _a);
            };
        },
        _d["start" + upperFirst(name) + "Fetch"] = function (_a) {
            var _b = name + "Fetcher", prevState = _a[_b];
            return function () {
                var _a;
                return (_a = {},
                    _a[name + "Fetcher"] = __assign({}, prevState, { loading: true }),
                    _a);
            };
        },
        _d)), withHandlers((_e = {},
        _e["fetch" + upperFirst(name)] = function (props) { return function () {
            props["start" + upperFirst(name) + "Fetch"]();
            fetch(props).then(props["receive" + upperFirst(name) + "Data"], props["receive" + upperFirst(name) + "Error"]);
        }; },
        _e)), mapProps(function (props) {
        return omit(props, [
            "receive" + upperFirst(name) + "Data",
            "receive" + upperFirst(name) + "Error",
            "start" + upperFirst(name) + "Fetch"
        ]);
    }), fetchOnMount
        ? lifecycle({
            componentDidMount: function () {
                this.props["fetch" + upperFirst(name)]();
            }
        })
        : identity);
}
export default withFetcher;
